import React, { useRef, useEffect, useState } from "react";


export default function CardDasboard(props) {
    return (
        <div className="dashboard-card-item">
            <div className={`m-0 py-0 mb-0 ${props.tipo === 1 ? 'bg-card-azul' : 'bg-card-azul2'} rounded-card h-100`}>
                <div className="col-md-12 mx-auto py-3">
                    <h3 className={props.tipo === 1 ? "text-azul" : 'text-light'}>
                        {props.titulo} <i className={props.icon}></i>
                    </h3>
                    <div className="row align-items-center justify-content-between px-0">
                        <div className="col-6 d-flex align-items-center justify-content-start">
                            <button type="button" onClick={props.print} className="btn btn-sm rounded-circle btn-light">
                                <i className="fas fa-print"></i>
                            </button>
                        </div>
                        <div className="col-6 d-flex justify-content-end">
                            <h1 className="bg-warning rounded-pill px-3">
                                 {props.cantidad} 
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
